import axios from "../../utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userActivity: [],
};

const userActivitySlice = createSlice({
  name: "userActivity",
  initialState,
  reducers: {
    setUserActivity: (state, action) => {
      state.userActivity = action.payload;
    },
  },
});

export function fetchUserActivity() {
  return async (dispatch) => {
    const impersonationToken = localStorage.getItem("impersonationToken");
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/user/activity`,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(userActivitySlice.actions.setUserActivity(response.data.data));
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export default userActivitySlice.reducer;
